import { render, staticRenderFns } from "./uuid.vue?vue&type=template&id=d8242c3a"
import script from "./uuid.vue?vue&type=script&lang=js"
export * from "./uuid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports